import gql from "graphql-tag";

export const deleteGroup = gql`
  mutation DeleteGroup($groupId: String!) {
    DeleteGroup(input: { groupId: $groupId }) {
      deleted
    }
  }
`;
